<template>
  <div class="emails">
    <ba-header activeModule="Emails"></ba-header>
    <div class="u-p4 main-content">
      <h2 class="c-heading__page u-mt4 u-pt2">Emails</h2>
      <div>
        <div class="u-mt3">
          <div class="u-mt4">
            <el-form inline>
              <el-form-item label="From" class="line-height-3"><el-date-picker v-model="range.from" type="date" format="MM/dd/yyyy" placeholder="Pick a date"></el-date-picker></el-form-item>
              <el-form-item label="To" class="line-height-3"><el-date-picker  v-model="range.to" type="date" format="MM/dd/yyyy" placeholder="Pick a date"></el-date-picker></el-form-item>
              <el-form-item label="Insured" class="line-height-3">
                <el-select v-model="selectedUserName" filterable>
                  <el-option  :selected="selectedUser===user.id"
                              v-for="user in usersList"
                              :value="user.id"
                              :label="user.name"
                              :key="user.id" />
                </el-select>
              </el-form-item>
              <el-form-item><el-button @click="loadPage(1)" icon="el-icon-search">Filter</el-button></el-form-item>
              <el-button v-if="range.from !== '' || range.to !== '' || this.selectedUser !== -1" @click="clearFilter">Clear Filter</el-button>
            </el-form>
          </div>
          <h2 class="u-pt2">Email Events</h2>
          <div class="u-mt5 u-mb2 download-failed-emails">
            <el-checkbox v-model="show_insured" @change="loadInitial()">Show Only Insured Email Events</el-checkbox>
            <el-button @click="downloadFailedEmailReportXls">Download Failed Email Report</el-button>
          </div>
          <el-table v-loading="loading" class="u-mt3 email-table" :data="items" style="width: 100%" :row-class-name="getStatusClassName">
            <el-table-column prop="short_description" label="Email Description"></el-table-column>
            <el-table-column prop="recipient_type" label="Type"></el-table-column>
            <el-table-column prop="related_user_name" label="Insured"></el-table-column>
            <el-table-column label="Event Date/Time">
              <template slot-scope="scope">
                {{ fixedTimestamp(scope.row.initiated_at) }}
              </template>
            </el-table-column>
            <el-table-column
                    label=""
                    width="120">
              <template slot-scope="scope">
                <el-button size="mini" @click="toggleRow(scope)"
                           v-if="!hasFailedEmailEvent(scope.row.email_events)">{{emailButtonLabel(scope.row)}}
                </el-button>

                <el-button size="mini" type="danger" @click="resendEmails(scope.row)" v-else>Resend</el-button>
              </template>
            </el-table-column>
            <el-table-column type="expand">
              <template slot-scope="group_scope">
                <div v-if="Object.keys(group_scope.row.additional_info.e_delivery).length">
                  <div class="el-card u-pb0">
                    <b>Policy</b>
                    <ul>
                      <li v-for="policyLink, policyNumber  in getPolicyNumbers(group_scope.row.additional_info)">
                        <span >
                          <a :href="policyLink" target="_blank" title="Will open in new tab">{{policyNumber}}</a>
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div class="el-card u-pb0">
                    <b>Document/Forms</b>
                    <ul>
                      <li v-for="edeliveryData, edeliveryId  in getEdeliverables(group_scope.row.additional_info)">
                        <span >
                          <a :href="edeliveryData.url" target="_blank" title="Will open in new tab">{{edeliveryData.title}}</a>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>

                <el-table v-loading="loading" :data="group_scope.row.email_events" style="width: 100%">
                  <el-table-column prop="subject" label="Subject" width="200"></el-table-column>
                  <el-table-column prop="recipient" label="Recipient" width="300"></el-table-column>
                  <el-table-column v-if="isSuperUser" prop="actual_recipient" label="Actual Recipient" width="300"></el-table-column>
                  <el-table-column prop="status" label="Status" class-name="col-capitalize-text"></el-table-column>
                  <el-table-column label="Event Date" width="200">
                    <template slot-scope="scope">
                      {{ fixedTimestamp(scope.row.sent_at) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                          label=""
                          width="95">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="toggleRow(scope)">Details</el-button>
                    </template>
                  </el-table-column>
                  <el-table-column type="expand">
                    <template slot-scope="event_scope">
                      <div class="mail-content" v-show="Object.keys(stripEventData(event_scope.row)).length">
                        <div class="el-card u-pb0">
                          <h4 class="c-heading--lg u-mb3 section">
                            <div class="section__name"> {{ stripEventData(event_scope.row).subject }}</div>
                          </h4>
                          <ul>
                            <li v-for="value, name in stripEventData(event_scope.row)" :class="[ show_content(name) ? '' : 'mail-content__hide' ]">
                              <div v-if="name == 'content'">
                                <b>{{getLabel(name)}}</b>
                                <el-popover
                                        placement="top-start"
                                        width="700"
                                        trigger="hover">
                                  <icon class="u-mr1 mail-content__icon" slot="reference" scale="1" :name="'envelope'"></icon>
                                  <div>
                                    <div class="mail-content__detail">
                                      <span v-html="value"/>
                                    </div>
                                  </div>
                                </el-popover>
                              </div>
                              <div v-else-if="name == 'attachments'">
                                <b>{{getLabel(name)}}</b>
                                <span v-for="attachment in value">
                                  <div v-if="attachment.attachment_strategy && attachment.attachment_strategy === 's3'">
                                    <a :href="linkForS3Attachment(attachment)" target="_blank">{{attachment.attachment_filename}}</a>
                                  </div>
                                  <a v-else @click="downloadAttachment(attachment.attachment_name, attachment.attachment_real_filename); $event.preventDefault();">{{attachment.attachment_name}}</a>
                                </span>
                              </div>
                              <span v-else>
                                <b>{{getLabel(name)}}</b>{{value}}
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </template>
                  </el-table-column>

                </el-table>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination class="u-mt4" :layout="paginationLayout"
                         :total="total" :page-size="perPage"
                         :current-page="page" @current-change="loadPage">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* esli1nt-disable */
import { mapState, mapGetters } from 'vuex'
import BaCompanyImage from '@/modules/appearance/company-image.component'
import ElButton from 'element-ui/packages/button/src/button'
import axios from 'axios'
import {axiosWrapper} from '@/shared/api.utils'
import config from '@/config'
import _ from 'lodash'
import * as moment from 'moment'

export default {
  components: {
    ElButton,
    BaCompanyImage,
  },
  name: 'ba-email',
  data () {
    return {
      companyId: this.$route.params.companyId,
      range: {
        from: '',
        to: '',
      },
      items: [],
      usersListBriteApps: [],
      selectedUser: -1,
      email_events: [],
      loading: true,
      total: 0,
      page: 1,
      numPages: 0,
      perPage: 20,
      show_insured: true,
    }
  },
  computed: {
    ...mapState('shared', ['user']),
    ...mapGetters('shared', ['companyById']),
    paginationLayout () {
      let moreThan15Pages = this.numPages > 15

      return moreThan15Pages ? 'prev, pager, next, jumper' : 'prev, pager, next'
    },

    isSuperUser () {
      return ((this.user !== undefined) && (this.user !== null)) ? this.user.is_superuser : false
    },
    usersList () {
      return [{id: -1, name: 'All'}].concat(this.usersListBriteApps)
    },
    selectedUserName: {
      get: function () {
        let user = _.find(this.usersList, user => {
          return user.id === this.selectedUser
        })
        return user.name
      },
      set: function (newValue) {
        this.selectedUser = newValue
      }
    },
  },
  beforeMount () {
    this.loading = true
    this.loadInitial()
  },
  methods: {
    async resendEmails (emailGroupEvent) {
      try {
        await this.$confirm(
          `This will resend failed email. Continue?`,
          'Resend failed emails'
        )
      } catch (e) {
        // user cancelled
        return
      }
      try {
        await axiosWrapper(axios.post(`${config.url}/company/${this.companyId}/resend-emails/`, {email_group_id: emailGroupEvent.id}))
        this.loadPage(1)
      } catch (error) {
        this.$message({
          type: 'error',
          message: `Failed to perform action. ${error.response.message}`
        })
      }
    },
    hasFailedEmailEvent (emailEvents) {
      for (let event of emailEvents) {
        if (event.status === 'failed' || event.status === 'technical failure') return true
      }
      return false
    },
    getStatusClassName ({row, rowIndex}) {
      if (this.hasFailedEmailEvent(row.email_events)) return 'failed-row'
      let rowClass = ''
      row.email_events.forEach(event => {
        if (rowClass.length === 0 && ['temporary-failure', 'retriable technical failure'].includes(event.status)) {
          rowClass = 'temporary-failed-row'
        } else if (rowClass.length === 0 && event.status === 'accepted') {
          rowClass = 'pending-row'
        }
      })
      return rowClass
    },
    getCompany () {
      return this.companyById(this.companyId)
    },
    getPolicyNumbers (additionalInfo) {
      let company = this.getCompany()
      let policyNumbersDict = {}
      let eDeliveryData = additionalInfo.e_delivery
      if (!eDeliveryData) {
        return policyNumbersDict
      }
      eDeliveryData.forEach(linkedEdeliveryUserEvent => {
        linkedEdeliveryUserEvent.linked_edeliveries.forEach(linkedEdelivery => {
          policyNumbersDict[linkedEdelivery.policy_number] = company.britecore_url + '/britecore/policies/information?policyId=' +
              linkedEdelivery.edeliverable_metadata.policy.id
        })
      })
      return policyNumbersDict
    },
    getEdeliverables (additionalInfo) {
      let company = this.getCompany()
      let edeliverablesDict = {}
      let eDeliveryData = additionalInfo.e_delivery
      if (!eDeliveryData) {
        return edeliverablesDict
      }
      eDeliveryData.forEach(linkedEdeliveryUserEvent => {
        linkedEdeliveryUserEvent.linked_edeliveries.forEach(linkedEdelivery => {
          let metadata = linkedEdelivery.edeliverable_metadata
          let title = metadata.file ? metadata.file.title : metadata.form.title
          let edeliverableBcId = metadata.file ? metadata.file.id : metadata.form.id
          edeliverablesDict[linkedEdelivery.id] = {
            url: company.britecore_url + '/gateway?file=core.uploads&method=getAttachment&id=' + edeliverableBcId,
            title: title
          }
        })
      })
      return edeliverablesDict
    },
    toggleRow (scope) {
      scope.store.table.toggleRowExpansion(scope.row)
    },
    stripEventData (selectedObject) {
      let data = _.pick(selectedObject, ['subject', 'user_name', 'status', 'status_details', 'recipient',
        'actual_recipient', 'content', 'recipient_type', 'attachments', 'bc_contact'])

      if (data['attachments'] == null) {
        delete data['attachments']
      }
      if (data['bc_contact'] == null) {
        delete data['bc_contact']
      }
      return data
    },
    loadInitial () {
      this.loadPage(1)
    },
    clearFilter () {
      this.range.from = ''
      this.range.to = ''
      this.selectedUser = -1
      return this.loadPage(1)
    },
    fixedTimestamp (timestamp) {
      return moment(new Date(timestamp)).format('MM/DD/YYYY hh:mm:ss A')
    },
    getLabel (text) {
      let temp = text.split('_')
      let rtnText = ''
      temp.forEach(function (str) {
        rtnText += str.charAt(0).toUpperCase() + str.slice(1) + ' '
      })
      return rtnText + ': '
    },
    emailButtonLabel (row) {
      let num = row.email_events.length
      let label = num + ' Email'
      if (num > 1) {
        label += 's'
      }

      return label
    },
    show_content (name) {
      if (name === 'actual_recipient') {
        if (!this.isSuperUser) {
          return false
        }
      }
      return true
    },
    linkForS3Attachment (attachment) {
      return `${config.url}/message-attachments/${attachment.attachment_id}/?token=${localStorage.carrierToken}`
    },
    downloadAttachment (fileName, realFileName) {
      let url = `${config.url}/company/${this.companyId}/email_attachment/` +
        `?attachment_real_filename=${realFileName}&file_name=${fileName}&token=${localStorage.carrierToken}`
      window.open(url, '_blank')
    },
    loadPage (page) {
      console.log('loadPage')
      this.loading = true

      let params = {
        page_size: this.perPage,
        page: page,
        from_date: this.$moment(this.range.from).format('MM-DD-YYYY'),
        to_date: this.$moment(this.range.to).format('MM-DD-YYYY'),
        insured_only: this.show_insured,
      }
      if (this.selectedUser !== -1) {
        params.user = this.selectedUser
      }

      axios.post(`${config.url}/company/${this.companyId}/email_group_events/`, params)
        .then((ret) => {
          this.items = ret.data.data.search_results.items
          this.usersListBriteApps = ret.data.data.users
          this.total = ret.data.data.search_results.total
          this.perPage = ret.data.data.search_results.page_size
          this.page = ret.data.data.search_results.page
          this.numPages = ret.data.data.search_results.num_pages
        })
        .finally(() => {
          this.loading = false
        })
    },
    encodeQueryData (data) {
      let ret = []
      for (let d in data) {
        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]))
      }
      return ret.join('&')
    },
    downloadFailedEmailReportXls () {
      let params = {
        from_date: this.$moment(this.range.from).format('MM-DD-YYYY'),
        to_date: this.$moment(this.range.to).format('MM-DD-YYYY'),
        insured_only: this.show_insured,
        token: localStorage.carrierToken
      }

      let url = config.url + '/company/' + this.companyId + '/get_failed_emails_xls/?' + this.encodeQueryData(params)
      window.open(url, '_blank')
    },
  },
}
</script>

<style scoped>

  .line-height-3 {
    line-height: 2em;
  }
  .download-failed-emails {
    overflow: hidden;
    margin-bottom: -20px;
  }
  .download-failed-emails > button {
    float: right;
  }

</style>
<style>
  .email-table .el-table__expanded-cell[class*=cell] {
    padding: 20px 20px !important;
  }
  .mail-content__icon {
    position: relative;
    top: 0.2em;
    color: #455b5f;
  }

  .mail-content__detail {
    word-break: normal;
  }

  .mail-content__icon:hover {
    color: #d8dce5;
  }

  .mail-content__hide {
    display: none;
  }

  .centered-break-all > div.cell {
    word-break: keep-all;
    text-align: center;
  }

  .col-capitalize-text > .cell {
    text-transform: capitalize;
  }
</style>

